<template>
  <div class="section">
    <div class="container">
      <h1>Using the Index E-Platform</h1>
      <video src="https://ctc-document.s3.amazonaws.com/useTheIndex.mp4" controls>
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>
